import React, { useEffect } from "react";
import { auth } from "../../firebase.js";

function WorkspaceCheckNoDisplay({ onWorkspaceCheck }) {
        useEffect(() => {
                const checkWorkspace = async () => {
                        try {
                                const user = auth.currentUser;
                                const token = user ? await user.getIdToken() : null;
                                const userUid = user ? user.uid : null;
                                if (!token) {
                                        console.error("User is not authenticated.");
                                        return;
                                }
                                const response = await fetch('https://bluebirddocumentationadmin.pythonanywhere.com/workspaces/', {
                                        method: "GET",
                                        headers: {
                                                'Content-Type': 'application/json',
                                                'Auth-Token': `Bearer ${token}`,
                                                'Authorization': `${token}`,
                                                'Requesting-User-Uid': userUid
                                        },
                                });
                                const data = await response.json();
                                
                                const workspaceExists = data && data.length > 0;
                                
                                // Check if user is an owner of any workspace
                                const isOwner = data.some(workspace => workspace.role === "OWNER");
                                
                                // Get workspace name from the first entry (all entries appear to have the same name)
                                const workspaceName = workspaceExists ? data[0].name : null;
                                
                                // Pass both the existence check, name, ownership status, and the full workspace array
                                onWorkspaceCheck(workspaceExists, workspaceName, isOwner, data);
                        } catch (error) {
                                console.error("Error checking workspace:", error);
                                onWorkspaceCheck(false, null, false, []);
                        }
                };
                checkWorkspace();
        }, [onWorkspaceCheck]);
        
        return null;
}

export default WorkspaceCheckNoDisplay;